import { UserSummaryCombinedProps } from './types';
import getProps from './UserSummary.props';

const usePresenter = (props: UserSummaryCombinedProps): UserSummaryCombinedProps => {
  const internalProps = getProps('');

  props = {
    ...props,
    name: {
      ...props.name,
      targetProps: {
        ...props.name?.targetProps,
        ...internalProps.name,
      },
    },
    email: {
      ...props.email,
      targetProps: {
        ...props.email?.targetProps,
        ...internalProps.email,
      },
    },
    role: {
      ...props.role,
      targetProps: {
        ...props.role?.targetProps,
        ...internalProps.role,
      },
    },
  };
  return props;
};

export default usePresenter;
